import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function RefundPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-10 max-w-4xl mx-auto">
      <button
        onClick={() => navigate(-1)}
        className="mb-6 inline-flex items-center gap-2 text-sm hover:opacity-80"
      >
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>

      <header className="mb-8">
        <h1 className="text-3xl font-bold">Refund Policy</h1>
        <p className="text-sm text-gray-500 mt-2">Last updated: September 30, 2025</p>
      </header>

      <section className="space-y-6">
        <p>
          We want you to be satisfied with Annotify. This Refund Policy outlines when refunds may be
          issued for purchases made through Paddle, our payment provider.
        </p>

        <h2 className="text-xl font-semibold">1. Free Trial and Evaluation</h2>
        <p>
          Where available, a free tier or trial allows you to evaluate the Service before
          subscribing. Please use this period to ensure the Service meets your needs.
        </p>

        <h2 className="text-xl font-semibold">2. Subscription Renewals</h2>
        <p>
          Subscriptions renew automatically until cancelled. You can cancel at any time effective at
          the end of the current billing period. We generally do not provide refunds for partial
          billing periods after renewal.
        </p>

        <h2 className="text-xl font-semibold">3. Refund Eligibility</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Duplicate charges caused by a billing error</li>
          <li>Unauthorized charges due to fraud (subject to investigation)</li>
          <li>Technical issues preventing reasonable use of the Service that cannot be resolved</li>
        </ul>
        <p>
          Requests are reviewed case-by-case and must be submitted within 14 days of the charge
          unless required otherwise by local law.
        </p>

        <h2 className="text-xl font-semibold">4. How to Request a Refund</h2>
        <p>
          Please contact <a className="text-club-accent" href="mailto:support@annotify.app">support@annotify.app</a> with your order number, purchase email, and a brief
          description of the issue. For transactions processed by Paddle, we may direct you to their
          support for resolution when appropriate.
        </p>

        <h2 className="text-xl font-semibold">5. Chargebacks</h2>
        <p>
          If you believe a charge is in error, please contact us first. Initiating a chargeback may
          delay resolution.
        </p>

        <h2 className="text-xl font-semibold">6. Changes</h2>
        <p>
          We may update this Refund Policy from time to time. We will post the updated version on
          this page with a new "Last updated" date.
        </p>
      </section>

      <footer className="mt-10">
        <Link to="/" className="text-club-accent">Back to Home</Link>
      </footer>
    </div>
  );
}
